// Jeu d'icônes SVG partagé (modules Anniversaire + Vérification) — mêmes conventions que
// GardenIcons/SkillIcons : viewBox 24x24, trait uniquement (jamais de remplissage), couleur reçue
// en prop. Les tracés sont des DONNÉES (pas du JSX) pour que web et mobile rendent exactement les
// mêmes formes : ce fichier est copié à l'identique dans OLTODO/utils/uiIcons.ts.
export type IconShape =
  | ["p", string]
  | ["c", number, number, number]
  | ["r", number, number, number, number, number]
  | ["l", number, number, number, number];

export type UiIconName =
  | "back" | "plus" | "check" | "close" | "trash" | "link" | "calendar" | "pin" | "users" | "chat"
  | "gift" | "cake" | "sparkle" | "userPlus" | "camera" | "idCard" | "passport" | "receipt" | "ticket"
  | "file" | "shieldCheck" | "clock" | "alert" | "eyeOff" | "lock" | "chevronRight" | "user" | "info"
  | "search" | "upload" | "steering" | "pencil";

export const UI_ICONS: Record<UiIconName, IconShape[]> = {
  back: [["p", "M19 12H5"], ["p", "M11 6l-6 6 6 6"]],
  plus: [["p", "M12 5v14"], ["p", "M5 12h14"]],
  check: [["p", "M5 12.5l4.5 4.5L19 7.5"]],
  close: [["p", "M6 6l12 12"], ["p", "M18 6L6 18"]],
  trash: [["p", "M4 7h16"], ["p", "M9 7V4.5h6V7"], ["p", "M6.5 7l1 13h9l1-13"], ["p", "M10 11v6"], ["p", "M14 11v6"]],
  link: [["p", "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"], ["p", "M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"]],
  calendar: [["r", 4, 5, 16, 16, 2.5], ["p", "M4 10h16"], ["p", "M8 3v4"], ["p", "M16 3v4"]],
  pin: [["p", "M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"], ["c", 12, 10, 2.4]],
  users: [["c", 9, 8, 3.2], ["p", "M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5"], ["p", "M16 5.2a3.2 3.2 0 0 1 0 5.6"], ["p", "M17.5 14.7c2.2.6 3.5 2.4 3.5 5.3"]],
  chat: [["p", "M21 12a8 8 0 0 1-11.8 7L4 20l1.2-4.6A8 8 0 1 1 21 12z"]],
  gift: [["r", 3, 8, 18, 4, 1], ["r", 5, 12, 14, 9, 1], ["p", "M12 8v13"], ["p", "M12 8C10.5 4 6 4.5 6 6.5S9 8 12 8z"], ["p", "M12 8c1.5-4 6-3.5 6-1.5S15 8 12 8z"]],
  cake: [["p", "M12 3v4"], ["p", "M11 3.5c0-.7.5-1 1-1.5.5.5 1 .8 1 1.5"], ["p", "M4 21v-6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6"], ["p", "M4 21h16"], ["p", "M4 17c1.3-1 2.7-1 4 0s2.7 1 4 0 2.7-1 4 0 2.7 1 4 0"]],
  sparkle: [["p", "M11 3l1.8 5.2L18 10l-5.2 1.8L11 17l-1.8-5.2L4 10l5.2-1.8z"], ["p", "M19 15l.7 1.8 1.8.7-1.8.7L19 20l-.7-1.8-1.8-.7 1.8-.7z"]],
  userPlus: [["c", 9, 8, 3.5], ["p", "M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6"], ["p", "M19 8v6"], ["p", "M16 11h6"]],
  camera: [["p", "M4 8h3l1.5-2.5h7L17 8h3v11H4z"], ["c", 12, 13, 3.5]],
  idCard: [["r", 3, 5, 18, 14, 2.5], ["c", 9, 11, 2.2], ["p", "M5.8 16c.6-1.4 1.8-2 3.2-2s2.6.6 3.2 2"], ["p", "M14.5 10h4"], ["p", "M14.5 13.5h3"]],
  passport: [["r", 5, 3, 14, 18, 2], ["c", 12, 10, 3], ["p", "M9 17h6"]],
  receipt: [["p", "M6 3h12v18l-3-2-3 2-3-2-3 2z"], ["p", "M9 8h6"], ["p", "M9 12h6"]],
  ticket: [["p", "M4 7h16v3a2 2 0 0 0 0 4v3H4v-3a2 2 0 0 0 0-4z"], ["p", "M14 7v2"], ["p", "M14 11v2"], ["p", "M14 15v2"]],
  file: [["p", "M7 3h7l5 5v13H7z"], ["p", "M14 3v5h5"]],
  shieldCheck: [["p", "M12 3l7 3v5.5c0 4.3-3 8.2-7 9.5-4-1.3-7-5.2-7-9.5V6z"], ["p", "M9 12l2.2 2.2L15.5 10"]],
  clock: [["c", 12, 12, 9], ["p", "M12 7v5l3 2"]],
  alert: [["c", 12, 12, 9], ["p", "M12 8v5"], ["p", "M12 16.2v.1"]],
  eyeOff: [["p", "M3 3l18 18"], ["p", "M10.6 6.1A9.6 9.6 0 0 1 12 6c5 0 8.5 4.5 9.5 6-.5.8-1.5 2.1-3 3.3"], ["p", "M6.7 7.9C4.6 9.3 3.2 11.2 2.5 12c1 1.5 4.5 6 9.5 6 1.2 0 2.3-.3 3.3-.7"], ["p", "M9.9 10a3 3 0 0 0 4.1 4.1"]],
  lock: [["r", 5, 11, 14, 10, 2], ["p", "M8 11V7a4 4 0 0 1 8 0v4"], ["c", 12, 16, 1.4]],
  chevronRight: [["p", "M9 5l7 7-7 7"]],
  user: [["c", 12, 8, 4], ["p", "M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5"]],
  info: [["c", 12, 12, 9], ["p", "M12 11v5"], ["p", "M12 7.8v.1"]],
  search: [["c", 11, 11, 6.5], ["p", "M16 16l4.5 4.5"]],
  upload: [["p", "M12 16V4"], ["p", "M7 9l5-5 5 5"], ["p", "M5 20h14"]],
  pencil: [["p", "M4 20l1-4L16.5 4.5a2 2 0 0 1 3 3L8 19z"], ["p", "M14.5 6.5l3 3"]],
  steering: [["c", 12, 12, 9], ["c", 12, 12, 2], ["p", "M3.5 10.5c3 .8 5.5 1 8.5 1.5"], ["p", "M20.5 10.5c-3 .8-5.5 1-8.5 1.5"], ["p", "M12 14v6.8"]],
};
